import { render, staticRenderFns } from "./editor-Video.vue?vue&type=template&id=e7c65518&lang=pug&"
import script from "./editor-Video.vue?vue&type=script&lang=js&"
export * from "./editor-Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports